import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { OperationWizardModule } from '../common/operation-wizard/operation-wizard.module';
import { ProductsModuleProviders } from '../pages/shared/products/products.module';
import { ProductsCreatePageModule } from '../products/products-create-page/products-create-page.module';

import { HistorySectionModule } from './history-section/history-section.module';
import { InsuranceSectionModule } from './insurance-section/insurance-section.module';
import { MainSectionModule } from './main-section/main-section.module';
import { MessagesModule } from './messages/messages.module';
import { PromotionsModule } from './promotions/promotions.module';
import { SectionsRoutingModule } from './sections-routing.module';
import { SectionsComponent } from './sections.component';
import { EmailFacade } from './settings/email.facade';
import { UpdatePassportDataWizardComponent } from './settings/update-passport-data-wizard/update-passport-data-wizard.component';
import { StatementsSectionModule } from './statements-section/statements-section.module';
import { SuggestionsSectionModule } from './suggestions-section/suggestions-section.module';

@NgModule({
	imports: [
		CommonModule,
		SectionsRoutingModule,

		MainSectionModule,
		SuggestionsSectionModule,
		InsuranceSectionModule,
		ProductsCreatePageModule,
		MessagesModule,
		PromotionsModule,
		StatementsSectionModule,
		OperationWizardModule,
		HistorySectionModule,
	],
	declarations: [
		SectionsComponent,
		UpdatePassportDataWizardComponent,
	],
	providers: [

		...ProductsModuleProviders,
		EmailFacade,
	],
})
export class SectionsModule { }
